import React from "react";
import { Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";

export interface TileWithImageProps {
  integrationImage: React.ReactElement;
  sandboxName: string;
  categoryName: string;
  sandboxURL: string;
}

const SandboxTile = ({
  integrationImage,
  sandboxName,
  categoryName,
  sandboxURL,
}: TileWithImageProps) => (
  <div className="flex flex-col gap-y-3 items-center">
    <Button
      variant={ButtonVariant.TertiaryWhite}
      onClick={() => window.open(sandboxURL, "_blank")}
      className="py-6 flex flex-col items-center gap-y-3 w-full"
    >
      {integrationImage}
      <Text variant="h6">{sandboxName} sandbox</Text>
    </Button>
    <Text variant="sm" className="text-gray-40">
      {categoryName}
    </Text>
  </div>
);

export default SandboxTile;
